/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteMcpListServerHeaders } from "../funcs/remoteMcpListServerHeaders.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListServerHeadersResult } from "../models/components/listserverheadersresult.js";
import {
  ListRemoteMcpServerHeadersRequest,
  ListRemoteMcpServerHeadersSecurity,
} from "../models/operations/listremotemcpserverheaders.js";
import { unwrapAsync } from "../types/fp.js";
export type RemoteMcpServerHeadersQueryData = ListServerHeadersResult;

export function prefetchRemoteMcpServerHeaders(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListRemoteMcpServerHeadersRequest,
  security?: ListRemoteMcpServerHeadersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRemoteMcpServerHeadersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRemoteMcpServerHeadersQuery(
  client$: GramCore,
  request: ListRemoteMcpServerHeadersRequest,
  security?: ListRemoteMcpServerHeadersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RemoteMcpServerHeadersQueryData>;
} {
  return {
    queryKey: queryKeyRemoteMcpServerHeaders({
      remoteMcpServerId: request.remoteMcpServerId,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function remoteMcpServerHeadersQueryFn(
      ctx,
    ): Promise<RemoteMcpServerHeadersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(remoteMcpListServerHeaders(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRemoteMcpServerHeaders(
  parameters: {
    remoteMcpServerId: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "remoteMcp", "listServerHeaders", parameters];
}
